import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import "./aboutUs.scss"
import photo from "../../../media/img/companyInfo/bajo-angulo-de-vista-de-los-rascacielos.jpg"

const AboutUs = () => {
    const { t } = useTranslation();

    const daromaInfo = [
        {
            id: 1,
            numeroFinal: 69,
            key: "happyClients"
        },
        {
            id: 2,
            numeroFinal: 15,
            key: "employees"
        },
        {
            id: 3,
            numeroFinal: 25,
            key: "toolsAccess"
        },
        {
            id: 4,
            numeroFinal: 150,
            key: "completedProjects"
        }
    ];

    // Estados para cada contador
    const [clientesFelices, setClientesFelices] = useState(0);
    const [empleados, setEmpleados] = useState(0);
    const [herramientas, setHerramientas] = useState(0);
    const [proyectos, setProyectos] = useState(0);

    // Función para animar los contadores
    const animateCounter = (setter, target) => {
        const duration = 2000;
        const steps = 50;
        const increment = target / steps;
        let current = 0;

        // Creación del intervalo de animación
        const timer = setInterval(() => {
            current += increment;
            if (current >= target) {
                current = target;
                clearInterval(timer); // Detiene el intervalo cuando llegamos al final
            }
            setter(Math.round(current));
        }, duration / steps);
    };

    useEffect(() => {
        // Iniciar todas las animaciones
        animateCounter(setClientesFelices, daromaInfo[0].numeroFinal);
        animateCounter(setEmpleados, daromaInfo[1].numeroFinal);
        animateCounter(setHerramientas, daromaInfo[2].numeroFinal);
        animateCounter(setProyectos, daromaInfo[3].numeroFinal);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Array con los valores actuales de los contadores en el mismo orden que daromaInfo
    const counterValues = [clientesFelices, empleados, herramientas, proyectos];

    const lineRefs = useRef([]);

    useEffect(() => {
        const observerOptions = {
            threshold: 0.2,
            rootMargin: '0px 0px 0px 0px'
        };

        const lineObservers = lineRefs.current.map((lineRef) => {
            if (!lineRef) return null;

            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('content__title-line--visible');
                        observer.unobserve(entry.target);
                    }
                });
            }, observerOptions);

            observer.observe(lineRef);
            return observer;
        });

        return () => {
            lineObservers.forEach(obs => obs?.disconnect());
        };
    }, []);

    return (
        <div className='companyInfo__aboutUs'>
            <section className='aboutUs'>
                <div className='aboutUs__imageContainer'>
                    <img src={photo} alt={t('about.header.title')} className="aboutUs__image" />
                </div>
                <div className="aboutUs__lineatop"></div>
                <div className="aboutUs__lineabottom"></div>
                <div className='aboutUs__header'>
                    <h1 className='header-title__main-page'>{t('about.header.title')}</h1>
                    <div
                        ref={el => lineRefs.current[0] = el}
                        className="content__title-line"
                    />
                    <p className='header-subtitle__main-page'>{t('about.header.subtitle')}</p>
                </div>
                <div className='aboutUs__container'>
                    {daromaInfo.map((info, index) => (
                        <div key={info.id} className='aboutUs__card'>
                            <div className='aboutUs__number'>{counterValues[index]}</div>
                            <p className=' aboutUs__description content__text-paragrah-title-backgroundDark'>{t(`about.header.${info.key}`)}</p>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
};

export default AboutUs;

